// pages/TermsPage.tsx
import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="pt-20 min-h-screen bg-gray-50">
      <div className="bg-gradient-to-br from-blue-900 via-purple-900 to-pink-900 py-20 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 text-center">
            Käyttöehdot
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto text-center">
            FennoFuture verkkosivuston ja palveluiden käyttöehdot
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-50 via-gray-50/50 to-transparent pointer-events-none" />
      </div>

      <div className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">

            <section>
              <h2 className="text-2xl font-bold mb-4">1. Yleiset ehdot ja soveltamisala</h2>
              <p className="text-gray-700 mb-3">
                Nämä yleiset sopimusehdot ("Ehdot") koskevat FennoFuture:n (Y-tunnus 3203489-7, "Yritys", "me", "meidän")
                tarjoamia tuotteita ja palveluita sekä verkkosivuston käyttöä. Käyttämällä palveluitamme tai tekemällä
                tilauksen hyväksyt nämä ehdot ja sitoudut noudattamaan niitä.
              </p>
              <p className="text-gray-700">
                Nämä ehdot muodostavat oikeudellisesti sitovan sopimuksen asiakkaan ja yrityksen välille. Pidätämme
                oikeuden muuttaa näitä ehtoja ilmoittamalla muutoksista verkkosivustollamme vähintään 30 päivää ennen
                muutosten voimaantuloa. Olemassa oleviin sopimuksiin sovelletaan tilaushetkellä voimassa olleita ehtoja.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">2. Palvelun käyttö ja velvollisuudet</h2>
              <p className="text-gray-700 mb-3">
                Asiakas sitoutuu käyttämään palveluitamme ja verkkosivustoamme:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Voimassa olevan Suomen lainsäädännön ja EU-säädösten mukaisesti</li>
                <li>Näiden käyttöehtojen ja mahdollisten erillisten sopimusten mukaisesti</li>
                <li>Hyvän liiketavan ja ammattietiikan mukaisesti</li>
                <li>Kunnioittaen muiden käyttäjien, kolmansien osapuolten ja yrityksen oikeuksia</li>
                <li>Oikeellisin ja ajantasaisin tiedoin</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Asiakas vastaa kaikista toimistaan ja laiminlyönneistään palveluita käyttäessään. Asiakas sitoutuu
                korvaamaan yritykselle kaikki vahingot, jotka aiheutuvat näiden ehtojen tai sovellettavan lainsäädännön
                vastaisesta toiminnasta.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">3. Tilaukset, tarjoukset ja sopimukset</h2>
              <p className="text-gray-700 mb-3">
                Tilausten ja palveluiden toimitus perustuu seuraaviin periaatteisiin:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Kaikki tarjouksemme ovat voimassa 30 päivää antamispäivästä, ellei toisin mainita</li>
                <li>Tarjouksen hyväksyminen muodostaa sitovan sopimuksen osapuolten välille</li>
                <li>Pidätämme oikeuden kieltäytyä tilauksen vastaanottamisesta ilman perusteluja</li>
                <li>Toimitusajat ovat arvioita ja voivat vaihdella olosuhteiden mukaan</li>
                <li>Sopimukseen sovelletaan tilaushetkellä voimassa olevia hintoja ja ehtoja</li>
                <li>Kirjalliset sopimukset ja vahvistukset syrjäyttävät suulliset sopimukset</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Pidätämme oikeuden tehdä kohtuullisia muutoksia toimituksiin, jos ne johtuvat teknisistä syistä,
                materiaalien saatavuudesta tai muista vastaavista perustelluista syistä. Merkittävistä muutoksista
                ilmoitetaan asiakkaalle viipymättä.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">4. Hinnoittelu ja arvonlisävero</h2>
              <p className="text-gray-700 mb-3">
                Hinnoittelussa noudatetaan seuraavia periaatteita:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Hintoihin lisätään kulloinkin voimassa oleva arvonlisävero (ALV), ellei toisin mainita</li>
                <li>Hinnat ovat voimassa tarjouksen tai tilausvahvistuksen antamishetkellä</li>
                <li>Pidätämme oikeuden muuttaa hintoja ilman ennakkoilmoitusta uusissa tilauksissa</li>
                <li>Olemassa oleviin tilauksiin sovelletaan tilaushetkellä sovittuja hintoja</li>
                <li>Mahdolliset toimitus-, asennus- ja muut lisäkustannukset ilmoitetaan erikseen</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Mikäli arvonlisäverokannat muuttuvat tilauksen ja toimituksen välisenä aikana, sovelletaan
                toimitushetken verokantoja. Hinnanmuutoksista johtuen asiakas voi peruuttaa tilauksen ilman
                kustannuksia, mikäli hinnanmuutos on yli 10%.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">5. Maksu ja laskutus</h2>
              <p className="text-gray-700 mb-3">Maksuehdot ja -käytännöt:</p>

              <p className="text-gray-700 mb-4">
                <strong>Yritysasiakkaat:</strong> Yritysasiakkaille maksuehto on 7 päivää netto laskun päivämäärästä,
                ellei toisin sovita. Ensimmäisessä tilauksessa voidaan edellyttää ennakkomaksua.
              </p>

              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Viivästyneestä maksusta peritään viivästyskorkoa korkolain mukaisesti</li>
                <li>Pidätämme omistusoikeuden tuotteisiin kunnes maksu on suoritettu kokonaisuudessaan</li>
                <li>Maksamattomat laskut siirretään perintään kuluttajansuojalain mukaisesti</li>
                <li>Perintäkulut ja oikeudenkäyntikulut ovat asiakkaan vastuulla</li>
                <li>Hyväksymme maksutapoina pankkisiirron, korttimaksun ja laskun (yritysasiakkaat)</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Mikäli asiakas laiminlyö maksun, meillä on oikeus keskeyttää työ ja/tai periä koko jäljellä oleva summa
                välittömästi. Maksuviivästys oikeuttaa meidät purkamaan sopimuksen ja vaatimaan korvauksia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">6. Takuu ja virhevastuu</h2>
              <p className="text-gray-700 mb-3">
                Takuuehdot ja vastuunrajoitukset:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Tarjoamme 12 kuukauden rajoitetun takuun valmistus- ja asennusvirheille</li>
                <li>Takuu edellyttää tuotteen/palvelun käyttöä normaaliolosuhteissa tarkoituksenmukaisesti</li>
                <li>Takuu ei koske normaalia kulumista, väärinkäytöstä tai vahingosta johtuvia vaurioita</li>
                <li>Takuukorjaukset suoritetaan kohtuullisessa ajassa työjärjestyksemme mukaisesti</li>
                <li>Vastaamme tuotteidemme ja palveluidemme kuluttajansuojalain mukaisesta virhevastuusta</li>
                <li>Välilliset vahingot (esim. tuotannon keskeytyminen, ansionmenetys) eivät sisälly vastuuseemme</li>
                <li>Korvausvastuumme enimmäismäärä rajoittuu tilauksen arvoon</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Yritysasiakkaiden osalta vastaamme vain välittömistä vahingoista, jotka johtuvat törkeästä
                huolimattomuudesta tai tahallisesta toiminnasta. Kuluttaja-asiakkaisiin sovelletaan kuluttajansuojalain
                pakottavia säännöksiä.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">7. Immateriaalioikeudet ja luottamuksellisuus</h2>
              <p className="text-gray-700 mb-3">
                Kaikki verkkosivuston sisältö, mukaan lukien mutta ei rajoittuen tekstit, kuvat, grafiikat, logot,
                tietokantasisältö, suunnitelmat, piirustukset ja ohjelmistokoodit, ovat yrityksen tai sen
                lisenssinantajien omaisuutta ja suojattu tekijänoikeus-, tavaramerkki- ja muilla immateriaalioikeuslaeilla.
              </p>
              <p className="text-gray-700 mb-3">
                Sisältöä ei saa:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Kopioida, jäljentää tai levittää ilman kirjallista lupaa</li>
                <li>Muokata, muuntaa tai luoda johdannaisteoksia</li>
                <li>Käyttää kaupallisiin tarkoituksiin ilman lupaa</li>
                <li>Poistaa tekijänoikeus- tai tavaramerkkimerkintöjä</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Asiakas myöntää yritykselle ei-yksinoikeudellisen, rojaltivapaan lisenssin käyttää ja hyödyntää
                asiakkaan toimittamia tietoja palveluiden toimittamiseksi. Molemmat osapuolet sitoutuvat pitämään
                luottamuksellisina kaikki liiketoimintaan liittyvät tiedot.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">8. Peruutus- ja palautusoikeus</h2>
              <p className="text-gray-700 mb-3">
                Kuluttajilla on 14 päivän peruutusoikeus kuluttajansuojalain mukaisesti, ellei kyse ole:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Räätälöidyistä tai asiakkaan spesifikaation mukaan valmistetuista tuotteista</li>
                <li>Palveluista, jotka on suoritettu kokonaan kuluttajan nimenomaisella suostumuksella</li>
                <li>Kiireellisistä korjaus- tai huoltotöistä, jotka kuluttaja on nimenomaisesti pyytänyt</li>
                <li>Pilaantuvista tai nopeasti vanhenevista tuotteista</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Yritysasiakkailla ei ole lakisääteistä peruutusoikeutta. Peruutuksen yhteydessä palautetaan jo maksetut
                suoritukset, vähennettynä kohtuulliset kulut jo tehdystä työstä tai hankituista materiaaleista.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">9. Reklamaatiot ja virhevastuun vanhentuminen</h2>
              <p className="text-gray-700 mb-3">
                Reklamaatioaikoja ja -menettelyä koskevat seuraavat ehdot:
              </p>
              <p className="text-gray-700 mb-3">
                <strong>Kuluttajat:</strong> Virheestä on reklamoitava kohtuullisessa ajassa virheen havaitsemisesta.
                Suosittelemme reklamoimaan viimeistään 2 viikon kuluessa virheen havaitsemisesta. Kuluttajansuojalain
                mukaiset vanhentumisajat pysyvät voimassa.
              </p>
              <p className="text-gray-700 mb-3">
                <strong>Yritysasiakkaat:</strong> Reklamaation on tapahduttava viimeistään 1 kuukauden kuluessa
                virheen havaitsemisesta tai siitä, kun virhe olisi pitänyt havaita. Reklamaatio on tehtävä kirjallisesti
                ja siinä on yksilöitävä virhe riittävän tarkasti.
              </p>
              <p className="text-gray-700 mt-3">
                Reklamaatiot tulee osoittaa: innovation@fennofuture.fi tai +358 400 416 466.
                Vastaamme reklamaatioihin viipymättä ja pyrimme ratkaisemaan asian 14 päivän kuluessa.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">10. Ylivoimainen este (Force Majeure)</h2>
              <p className="text-gray-700 mb-3">
                Emme vastaa viivästyksistä, vahingosta tai muusta sopimusrikkomuksesta, joka aiheutuu ylivoimaisesta
                esteestä, kuten:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Luonnonkatastrofit (tulva, myrsky, maanjäristys)</li>
                <li>Sota, mellakat, terrori-iskut</li>
                <li>Lakot, työsulut tai muut työtaistelutoimenpiteet</li>
                <li>Viranomaistoimenpiteet tai lainsäädännön muutokset</li>
                <li>Energia- tai raaka-ainepula</li>
                <li>Tulipalo, räjähdys tai muu vastaava vahinkotapahtuma</li>
                <li>Alihankkijan tai toimittajan viivästys ylivoimaisen esteen vuoksi</li>
                <li>Pandemiat, epidemiat tai muut poikkeukselliset terveysriskit</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Ylivoimaisen esteen sattuessa ilmoitamme siitä asiakkaalle viipymättä ja pyrimme minimoimaan haitat.
                Mikäli ylivoimainen este kestää yli 3 kuukautta, kummallakin osapuolella on oikeus purkaa sopimus
                ilman korvausvelvollisuutta.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">11. Tietosuoja ja henkilötietojen käsittely</h2>
              <p className="text-gray-700">
                Käsittelemme henkilötietoja EU:n yleisen tietosuoja-asetuksen (GDPR) ja Suomen tietosuojalainsäädännön
                mukaisesti. Yksityiskohtaiset tiedot henkilötietojen käsittelystä löytyvät erillisestä
                <a href="/privacy" className="text-purple-600 hover:underline"> tietosuojaselosteestamme</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">12. Muutokset ehtoihin</h2>
              <p className="text-gray-700">
                Pidätämme oikeuden muuttaa näitä ehtoja. Muutoksista ilmoitetaan verkkosivustollamme vähintään 30 päivää
                ennen niiden voimaantuloa. Merkittävistä muutoksista ilmoitamme myös sähköpostitse rekisteröityneille
                asiakkaille. Olemassa oleviin sopimuksiin sovelletaan sopimushetkellä voimassa olleita ehtoja, ellei
                lainsäädäntö toisin edellytä. Jatkamalla palveluidemme käyttöä muutosten voimaantulon jälkeen hyväksyt
                muutetut ehdot.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">13. Sovellettava laki ja riitojen ratkaiseminen</h2>
              <p className="text-gray-700 mb-3">
                Näihin ehtoihin ja niiden tulkintaan sovelletaan Suomen lakia, poislukien lainvalintaa koskevat säännökset.
                Viittaus Suomen lakiin sisältää myös sovellettavat EU-säädökset.
              </p>
              <p className="text-gray-700 mb-3">
                Erimielisyydet pyritään ratkaisemaan ensisijaisesti neuvottelemalla osapuolten välillä. Mikäli sovintoa
                ei saavuteta 30 päivän kuluessa, riita ratkaistaan ensiasteessa Pirkanmaan käräjäoikeudessa Tampereella.
              </p>
              <p className="text-gray-700">
                Kuluttajilla on oikeus saattaa riita-asia käsiteltäväksi myös kuluttajariitalautakunnassa
                (www.kuluttajariita.fi) tai EU:n kuluttajariidanratkaisualustalla (ec.europa.eu/consumers/odr).
                Kuluttaja voi nostaa kanteen myös oman asuinpaikkansa käräjäoikeudessa.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">14. Yhteystiedot ja asiakaspalvelu</h2>
              <p className="text-gray-700"><strong>FennoFuture</strong></p>
              <p className="text-gray-700">Y-tunnus: 3203489-7</p>
              <p className="text-gray-700">Osoite: Turuntie 3, 37830 Akaa</p>
              <p className="text-gray-700">Sähköposti: innovation@fennofuture.fi</p>
              <p className="text-gray-700">Puhelin: +358 400 416 466</p>
              <p className="text-gray-700 mt-3">Asiakaspalvelu: Ma-Pe 8:00-16:00</p>
            </section>

            <section className="border-t pt-6">
              <p className="text-sm text-gray-600">
                <strong>Päivitetty:</strong> 8.1.2026
              </p>
              <p className="text-sm text-gray-600 mt-2">
                <strong>Versio:</strong> 2.1
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
